<template>
  <div class="page">
    <!-- ==========顶部固定Header【放返回按钮】 ========== -->
    <header class="page-header">
      <button class="back-btn" @click="$router.go(-1)">
        返回
      </button>
      <h2 class="page-title">添加足迹</h2>
    </header>

    <!-- ==========中间表单区域（可滚动） ========== -->
    <div class="form-wrap">
      <div class="form-scroll">
        <!-- ============【新增：归属选择下拉】============ -->
       <div class="form-item" v-if="groupTreeData.length > 0" ref="belongWrap">
          <label>
            <span style="font-weight:700;">记录归属</span>
            <span style="color:red">*</span>
            <span style="font-size:12px; color:#666; margin-left:6px;">（谨慎选择，足迹将归属选中小组）</span>
          </label>

          <!-- 触发器：显示当前选中 -->
          <div class="belong-trigger" @click="belongOpen = !belongOpen">
            <span v-if="!selectedBelong" class="belong-placeholder">--请选择归属--</span>
            <span v-else class="belong-selected-text">{{ selectedBelongLabel }}</span>
            <span class="belong-arrow" :class="{ open: belongOpen }">▼</span>
          </div>

          <!-- 下拉面板 -->
          <div v-if="belongOpen" class="belong-panel">
            <!-- 个人选项（和分类统一结构） -->
            <div
              class="belong-row"
              @click="selectBelong('personal')"
            >
              <span class="type-dot"></span>
              <span class="belong-type-label">个人</span>
            </div>

            <!-- 各分类 -->
            <div
              v-for="typeItem in groupTreeData"
              :key="typeItem.typeKey"
              class="belong-row"
            >
              <span class="type-dot"></span>
              <span class="belong-type-label">{{ typeItem.typeLabel }}</span>
              <div class="belong-tags">
                <span
                  v-for="g in typeItem.groups"
                  :key="g.groupId"
                  class="belong-tag"
                  :class="{ active: selectedBelong === g.groupId }"
                  @click.stop="selectBelong(g.groupId, g.groupName)"
                >{{ g.groupName }}</span>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 省份 + 城市 + 同行人物 同一行 -->
        <div class="form-row">
          <div class="form-item short">
            <label>省份</label>
            <input v-model="form.province" readonly class="readonly-input" />
          </div>
          <div class="form-item short">
            <label>城市</label>
            <input v-model="form.city" readonly class="readonly-input" />
          </div>
          <div class="form-item grow">
            <label>与我相随</label>
            <input v-model="form.partner" placeholder="例：爸爸妈妈 / 好友" />
          </div>
        </div>

        <!-- 抵达时间 + 离开时间 同行一行 -->
        <div class="form-row">
          <div class="form-item half">
            <label>抵达时间</label>
            <input type="date" v-model="form.arriveTime" />
          </div>
          <div class="form-item half">
            <label>离开时间</label>
            <input type="date" v-model="form.leaveTime" />
          </div>
        </div>

        <div class="form-item">
          <label>身心所至</label>
          <input v-model="form.spots" placeholder="本次到访的各个具体景点" />
        </div>

        <div class="form-item">
          <label>美食共鉴</label>
          <input v-model="form.food" placeholder="品尝的美食" />
        </div>

        <div class="form-item">
          <label>安营扎寨</label>
          <input v-model="form.hotel" placeholder="酒店、民宿...（选填）" />
        </div>

        <div class="form-item">
          <label>印记存档<span class="word-count">{{wordLen}}/1000</span></label>
          <textarea
            v-model="form.note"
            maxlength="1000"
            placeholder="记录旅途故事、心得感受（最多1000字）"
            @input="calcWord"
          ></textarea>
        </div>

        <div class="form-item">
         <label>珍贵瞬间 <span style="color:#999;font-size:12px">（上传照片替换系统默认图）单次足迹限制上传{{ imgMaxCount }}张，如需上传更多图片请联系<span class="feedback-link" @click="$openFeedback">客服</span></span></label>
          <div class="img-box">
            <!-- 预览已选图片 -->
            <div class="img-item" v-for="(item,idx) in photoList" :key="idx">
              <img :src="item" alt="预览">
              <div class="del" @click="delImg(idx)">×</div>
            </div>
            <!-- 添加图片按钮 -->
            <label class="add-img">
              + 添加图片
              <input ref="fileInput" type="file" accept="image/*" multiple hidden @change="handleUpload" />
            </label>
          </div>
        </div>
      </div>
    </div>

    <!-- ==========底部固定提交按钮 ========== -->
    <div class="page-footer">
      <button class="submit-btn" @click="submitForm">提交保存</button>
    </div>

    <!-- 👇 新增：图片上传全局遮罩与进度条 -->
    <div v-if="uploading" class="upload-mask">
      <div class="upload-box">
        <h3>图片处理中...</h3>
        <el-progress :percentage="uploadPercent" :color="customColor"></el-progress>
        <p class="upload-tip">请勿关闭页面或刷新</p>
      </div>
    </div>
    <!-- 👇 新增：自定义查重提示弹窗 -->
    <div v-if="showDuplicateTip" class="tip-mask" @click.self="showDuplicateTip = false">
      <div class="tip-panel">
        <div class="tip-text">
  <div class="tip-title">温馨提示：</div>
  <div class="tip-desc">你已存在 {{ this.form.arriveTime }}的足迹印记，是否继续保存此条足迹印记？
</div>
</div>
        <div class="tip-btn-group">
          <button class="tip-btn cancel" @click="showDuplicateTip = false">返回修改</button>
          <button class="tip-btn confirm" @click="confirmDuplicateSave">确认保存</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import request from '@/utils/request'
import { getCurrentUser, setCurrentUser, saveFootprint, getGroupList , getFootprintList } from '@/api/footprint'
export default {
  data() {
    return {
      form: {
        province: "",
        city: "",
        arriveTime: "",
        leaveTime: "",
        partner: "",
        spots: "",
        food: "",
        hotel: "",
        note: ""
      },
      photoList: [],
      wordLen: 0,
      showDuplicateTip: false,
      isConfirmingSave: false,
      // ============新增归属相关数据============
      selectedBelong: "",
      selectedBelongLabel: "",
      groupTreeData: [],
      belongOpen: false,
      belongDisabled: false,
      imgMaxCount: 10,
      // ============新增上传进度数据============
      uploading: false,
      uploadPercent: 0,
      customColor: '#409eff'
    };
  },
  async mounted() {
    this.readRouteQuery();
    await this.loadGroupOptions();
    document.addEventListener('click', this.handleClickOutside);
    try {
      const user = await getCurrentUser()
      this.imgMaxCount = user.imgMaxCount || 10
    } catch (err) {
      this.imgMaxCount = 10
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  watch: {
    $route(to, from) {
      // 只有路由地址改变才执行，避免同query重复触发
      if(to.path !== from.path) {
        this.readRouteQuery();
        this.loadGroupOptions();
      }
    }
  },
  methods: {
    // ============加载小组下拉选项，全部改用api============
    async loadGroupOptions() {
      const user = await getCurrentUser()
      if (!user || !user.phone) {
        this.groupTreeData = []
        return
      }
      const userGroupIdList = Array.isArray(user.groupIdList) ? user.groupIdList : []
      if (userGroupIdList.length === 0) {
        this.groupTreeData = []
        this.selectedBelong = ''
        this.selectedBelongLabel = ''
        return
      }

      const groupList = await getGroupList()
      const myGroups = groupList.filter(g => userGroupIdList.includes(g.groupId))

      const typeMap = {
        'lover': '恋人伴侣',
        'child': '亲子眷幼',
        'parent': '孝亲伴老',
        'colleague': '同事',
        'friend': '朋友',
        'relative': '亲戚',
        'classmate': '同学'
      }

      const treeObj = {}
      myGroups.forEach(g => {
        let typeKey = g.groupType
        if (g.groupType === 'other') {
          typeKey = g.otherSubType
        }
        if (!treeObj[typeKey]) {
          treeObj[typeKey] = {
            typeKey,
            typeLabel: typeMap[typeKey] || typeKey,
            groups: []
          }
        }
        treeObj[typeKey].groups.push({
          groupId: g.groupId,
          groupName: g.groupName || typeMap[typeKey]
        })
      })

      this.groupTreeData = Object.values(treeObj)
      this.selectedBelong = ''
      this.selectedBelongLabel = ''
      this.belongOpen = false
    },

    // 点击外部关闭下拉框
    handleClickOutside(e) {
      if (!this.belongOpen) return
      const wrap = this.$refs.belongWrap
      if (wrap && !wrap.contains(e.target)) {
        this.belongOpen = false
      }
    },

    // 选中归属
    selectBelong(val, label) {
      this.selectedBelong = val
      if (val === 'personal') {
        this.selectedBelongLabel = '个人'
      } else {
        // 找一下对应的小组名称
        let found = ''
        for (const t of this.groupTreeData) {
          const g = t.groups.find(x => x.groupId === val)
          if (g) { found = g.groupName; break }
        }
        this.selectedBelongLabel = found || label || val
      }
      this.belongOpen = false
    },
    // 抽成公共函数，mounted 和 watch 共用
    readRouteQuery() {
      const query = this.$route.query;
      this.form.province = query.province || "";
      this.form.city = query.city || "";
      // 清空其他表单字段
      this.photoList = []
      this.form.arriveTime = ""
      this.form.leaveTime = ""
      this.form.partner = ""
      this.form.spots = ""
      this.form.food = ""
      this.form.hotel = ""
      this.form.note = ""
      this.wordLen = 0
      this.selectedBelong = "" // 切换路由清空归属选择
    },
    calcWord() {
      this.wordLen = this.form.note.length;
    },
     
    // 👇 修改：图片上传，加入全局遮罩与进度条
    async handleUpload(e) {
      const files = Array.from(e.target.files);
      if (!files.length) return;

      if (this.photoList.length + files.length > this.imgMaxCount) {
        alert(`最多上传${this.imgMaxCount}张图片，如需更多图片请联系客服`);
        e.target.value = "";
        return;
      }

      this.uploading = true; // 开启遮罩

      for (let i = 0; i < files.length; i++) {
        try {
          this.uploadPercent = 0; // 每次循环重置进度
          const blob = await this.compressImage(files[i], 1920, 0.7);
          const url = await this.uploadToServer(blob, (percent) => {
            this.uploadPercent = percent; // 实时更新进度
          });
          this.photoList.push(url);
        } catch (err) {
          console.error('上传失败', err);
          alert(err || '图片上传失败，请重试'); 
        }
      }
      
      this.uploading = false; // 关闭遮罩
      e.target.value = '';
    },

    // canvas 压缩
    compressImage(file, maxW, quality) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          img.onload = () => {
            const canvas = document.createElement('canvas');
            let width = img.width;
            let height = img.height;
            if (width > maxW) {
              const scale = maxW / width;
              width = maxW;
              height = height * scale;
            }
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);
            canvas.toBlob(blob => resolve(blob), 'image/jpeg', quality);
          };
        };
      });
    },

    // 👇 修改：上传到后端，增加进度回调
    uploadToServer(blob, progressCallback) {
      return new Promise(async (resolve, reject) => {
        try {
          const formData = new FormData();
          formData.append('file', blob, 'photo.jpg');
          const res = await request.post('/uploadImage', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: (progressEvent) => {
              if (progressCallback && progressEvent.total) {
                const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                progressCallback(percent);
              }
            }
          });
          if (res.success && res.url) {
            resolve(res.url);
          } else {
            reject(res.msg || '上传失败');
          }
        } catch (err) {
          reject(err);
        }
      });
    },
    delImg(idx) {
      this.photoList.splice(idx,1);
    },

    confirmDuplicateSave() {
      this.showDuplicateTip = false;
      this.isConfirmingSave = true; // 设置标记，绕过查重拦截
      this.submitForm(); // 再次执行提交
    },

    async submitForm() {
      // ===== 1. 敏感词过滤 =====
      const fields = [
        { label: '与我相随', val: this.form.partner },
        { label: '身心所至', val: this.form.spots },
        { label: '美食共鉴', val: this.form.food },
        { label: '安营扎寨', val: this.form.hotel },
        { label: '印记存档', val: this.form.note }
      ]
      for (const f of fields) {
        if (f.val && this.$hasSensitiveWord(f.val)) {
          this.$showToast(`「${f.label}」包含违规词汇，请修改后重试`)
          return
        }
      }

      // ===== 2. 基础时间校验 =====
      if (!this.form.arriveTime) {
        alert("请选择抵达时间");
        return;
      }
      if (this.form.leaveTime && this.form.leaveTime < this.form.arriveTime) {
        alert("离开时间不能早于抵达时间");
        return;
      }
      
      // 👇 核心！绝对拦截未来时间
      const today = new Date();
      // 格式化为 YYYY-MM-DD 以便和 input 的值对比
      const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
      if (this.form.arriveTime > todayStr) {
        alert("抵达时间不能晚于今天");
        return;
      }
      if (this.form.leaveTime && this.form.leaveTime > todayStr) {
        alert("离开时间不能晚于今天");
        return;
      }

      // ===== 3. 归属与城市校验 =====
      if (!this.form.province || !this.form.city) {
        alert("省份、城市信息缺失！");
        return;
      }
      if (this.groupTreeData.length > 0 && !this.selectedBelong) {
        alert("请选择这条足迹的归属");
        return;
      }

      // ===== 4. 查重提示 =====
      let belongGroupId = "";
      if (this.groupTreeData.length > 0) {
        if (this.selectedBelong && this.selectedBelong !== 'personal') {
          belongGroupId = this.selectedBelong;
        }
      }

      const user = await getCurrentUser();
      if (!user || !user.phone) {
        alert("请先登录账号");
        return;
      }

      const allFoots = await getFootprintList();
      
      // 👇 核心修改：只要抵达时间相同，就弹窗
      const duplicateRecord = allFoots.find(item => 
        item.createUserId === user.phone && 
        item.arriveTime === this.form.arriveTime
      );

      // 如果有重复记录，且当前不是在“确认保存”的状态，就弹出你自己的漂亮弹窗
      if (duplicateRecord && !this.isConfirmingSave) {
        this.showDuplicateTip = true;
        return; // 拦截，等待用户在弹窗里点确认
      }
      

      // ===== 5. 构建数据并保存 =====
      const newRecord = {
        id: Date.now(),
        createUserId: user.phone,
        province: this.form.province,
        city: this.form.city,
        arriveTime: this.form.arriveTime,
        leaveTime: this.form.leaveTime,
        partner: this.form.partner,
        spots: this.form.spots,
        food: this.form.food,
        hotel: this.form.hotel,
        note: this.form.note,
        photoList: this.photoList,
        belongGroupId: belongGroupId
      };

      const res = await saveFootprint(newRecord);
      if (res && res.success === false) {
        alert(res.msg || '保存失败，请重试');
        return;
      }

      // ===== 6. 更新本地缓存与跳转 =====
      let belongId = newRecord.belongGroupId;
      if (belongId) {
        user.currentGroupId = belongId;
      } else {
        user.currentGroupId = 'personal';
      }
      
      user.needRefreshMap = 1;
      await setCurrentUser(user);

      this.isConfirmingSave = false;

      alert("保存成功！");
      
      if (belongId) {
        this.$router.replace({
          path: "/province",
          query: { name: this.form.province, viewGroupId: belongId }
        });
      } else {
        this.$router.replace({
          path: "/province",
          query: { name: this.form.province }
        });
      }
    }
  }
}
</script>

<style scoped>
/* ============================================================
   1. 页面骨架
   ============================================================ */
.page {
  height: 100vh; 
  overflow: hidden; 
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Microsoft YaHei UI", "Microsoft YaHei", SimHei, sans-serif;
  color: #333;
  
  /* 统一全站云纹背景 */
  background-image: url("~@/assets/subtle.webp");
  background-repeat: repeat;
  background-size: 500px auto;
  background-position: center;
  background-color: rgba(247, 243, 233, 0.55);
}

/* ============================================================
   2. Header：高光玻璃导航
   ============================================================ */
.page-header {
  position: relative;
  z-index: 10;
  flex-shrink: 0;
  height: clamp(48px, 7vh, 68px); 
  display: flex;
  align-items: center;
  padding: 0 clamp(16px, 3vw, 24px); 
  gap: clamp(8px, 1.5vw, 16px);
  box-sizing: border-box;
  
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.05));
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.back-btn {
  border-radius: 8px; 
  padding: 0 clamp(8px, 1.2vw, 14px); 
  height: clamp(24px, 3.2vh, 28px); 
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.15));
  color: #fff;
  font-weight: 600;
  border: 1px solid rgba(255, 255, 255, 0.6);
    box-shadow: 
    0 4px 12px rgba(0, 0, 0, 0.1), 
    inset 0 2px 4px rgba(255, 255, 255, 0.9), /* 顶部强高光 */
    inset 0 -2px 4px rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(4px);
  font-size: clamp(11px, 1.1vw, 14px);
  line-height: 1.2; 
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.2s ease;
  text-shadow: 0 1px 2px rgba(0,0,0,0.15);
}
.back-btn:hover {
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.3));
  transform: translateY(-1px);
}
.back-btn:active {
  transform: translateY(1px) scale(0.96);
  box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.15);
}

.page-title {
  position: absolute !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  margin: 0 !important;
  color: #2c3e50 !important; 
  font-size: clamp(16px, 2.1vw, 22px) !important; 
  font-weight: 900 !important; 
  letter-spacing: 3px !important; 
  white-space: nowrap !important;
  pointer-events: none !important;
  line-height: 1.2 !important;
  text-shadow: 
    0 2px 4px rgba(255, 255, 255, 0.9),
    0 4px 12px rgba(255, 255, 255, 0.6),
    0 1px 0px rgba(255, 255, 255, 1) !important;
}

/* ============================================================
   3. 表单滚动区
   ============================================================ */
.form-wrap {
  flex: 1;
  overflow-y: auto;
  padding: clamp(8px, 1.5vw, 16px);
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
}

.form-scroll {
  /* 👇 降低一点底色透明度，让后面的云纹透得更明显 */
  background: rgba(255, 255, 255, 0.3); 
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  
  /* 👇 加上超亮的边框和内外双发光，像一块厚玻璃板 */
  border: 1px solid rgba(255, 255, 255, 0.9);
  border-radius: 16px;
  padding: clamp(12px, 2.5vw, 24px);
  box-shadow: 
    0 12px 32px rgba(0, 0, 0, 0.08), 
    inset 0 2px 6px rgba(255, 255, 255, 1), 
    inset 0 -2px 6px rgba(0, 0, 0, 0.05);
}
input, textarea {
  width: 100%;
  box-sizing: border-box;
  height: clamp(32px, 4.5vh, 40px); 
  
  /* 👇 用极低透明度的白色 + 高光边框 */
  background: rgba(255, 255, 255, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.9);
  border-radius: 8px;
  padding: 0 clamp(10px, 1.2vw, 14px);
  font-size: clamp(12px, 1.2vw, 14px);
  color: #2c3e50;
  outline: none;
  transition: all 0.2s;
  
  /* 👇 内阴影让它看起来是凹进去的 */
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.03), 0 1px 2px rgba(255,255,255,0.8);
}
input:focus, textarea:focus {
  background: rgba(255, 255, 255, 0.8);
  border-color: rgba(64, 158, 255, 0.8);
  box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.2), inset 0 2px 4px rgba(0, 0, 0, 0.02);
}
/* ============================================================
   4. 底部提交栏
   ============================================================ */
.page-footer {
  height: clamp(50px, 8vh, 68px);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  
  /* 👇 底部也做成高光玻璃 */
  background: linear-gradient(to top, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.05));
  border-top: 1px solid rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.08), inset 0 2px 4px rgba(255,255,255,1);
  padding-bottom: env(safe-area-inset-bottom);
}

.submit-btn {
  padding: clamp(4px, 1vh, 8px) clamp(24px, 4vw, 48px);
  border-radius: 8px;
  font-size: clamp(13px, 1.5vw, 16px);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.4);
  background: linear-gradient(to bottom, rgba(255,255,255,0.25), rgba(255,255,255,0) 50%), rgba(82, 196, 26, 0.85);
  box-shadow: 0 4px 12px rgba(82, 196, 26, 0.25), inset 0 1px 2px rgba(255, 255, 255, 0.5);
  text-shadow: 0 1px 2px rgba(0,0,0,0.15);
}
.submit-btn:hover {
  background: linear-gradient(to bottom, rgba(255,255,255,0.35), rgba(255,255,255,0) 50%), rgba(82, 196, 26, 0.95);
  transform: translateY(-1px);
}
.submit-btn:active {
  transform: translateY(1px) scale(0.96);
}

/* ============================================================
   5. 表单元素
   ============================================================ */
.form-row {
  display: flex;
  gap: clamp(8px, 1.5vw, 16px);
  flex-wrap: wrap;
  margin-bottom: 2px;
}

.form-item {
  margin-bottom: clamp(8px, 1.5vh, 12px); 
  width: 100%;
  box-sizing: border-box;
 position: relative; 
}
.form-item.short { width: 28%; }
.form-item.grow { flex: 1; }
.form-item.half { width: calc(50% - 8px); }

.form-item label {
  display: block;
  margin-bottom: clamp(4px, 0.8vh, 6px);
  font-size: clamp(12px, 1.2vw, 14px);
  color: #2c3e50;
  font-weight: 600;
}
.word-count {
  color: #888;
  font-size: clamp(10px, 1vw, 12px) !important;
  float: right;
  font-weight: normal;
}

input {
  width: 100%;
  box-sizing: border-box;
  height: clamp(30px, 4.5vh, 38px); 
  border: 1px solid rgba(255, 255, 255, 0.8);
  background: rgba(255, 255, 255, 0.6);
  border-radius: 8px;
  padding: 0 clamp(8px, 1vw, 12px);
  font-size: clamp(12px, 1.2vw, 14px);
  color: #333;
  outline: none;
  transition: all 0.2s;
}
input:focus {
  border-color: #409eff;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
}

textarea {
  width: 100%;
  box-sizing: border-box;
  min-height: clamp(70px, 10vh, 100px); 
  border: 1px solid rgba(255, 255, 255, 0.8);
  background: rgba(255, 255, 255, 0.6);
  border-radius: 8px;
  padding: clamp(6px, 1vh, 10px) clamp(8px, 1vw, 12px);
  font-size: clamp(12px, 1.2vw, 14px);
  color: #333;
  outline: none;
  resize: vertical;
}
textarea:focus {
  border-color: #409eff;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
}

.readonly-input {
  background: rgba(230, 234, 237, 0.7) !important;
  color: #888 !important;
  cursor: not-allowed;
  border-color: rgba(208, 212, 218, 0.8) !important;
  box-shadow: inset 0 1px 3px rgba(0,0,0,0.05) !important;
}

/* ============================================================
   6. 图片上传区
   ============================================================ */
.img-box {
  display: flex;
  gap: clamp(8px, 1.5vw, 12px);
  flex-wrap: wrap;
  margin-top: 8px;
}
.img-item {
  width: clamp(70px, 10vw, 100px);
  height: clamp(70px, 10vw, 100px);
  position: relative;
}
.img-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid rgba(255,255,255,0.6);
}
.del {
  position: absolute;
  top: -6px; right: -6px;
  background: #f56c6c;
  color: #fff;
  border-radius: 50%;
  width: clamp(16px, 2vw, 20px);
  height: clamp(16px, 2vw, 20px);
  text-align: center;
  line-height: clamp(16px, 2vw, 20px);
  cursor: pointer;
  font-size: clamp(12px, 1.5vw, 14px);
  box-shadow: 0 2px 6px rgba(245, 108, 108, 0.4);
}
.add-img {
  width: clamp(70px, 10vw, 100px);
  height: clamp(70px, 10vw, 100px);
  border: 1px dashed rgba(150, 150, 150, 0.5);
  background: rgba(255,255,255,0.4);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  cursor: pointer;
  font-size: clamp(11px, 1vw, 13px);
  transition: all 0.2s;
}
.add-img:hover {
  background: rgba(255,255,255,0.7);
  border-color: #409eff;
  color: #409eff;
}
.add-img input { display: none; }

/* ============================================================
   7. 记录归属下拉框（高光琉璃）
   ============================================================ */
.belong-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(255, 255, 255, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.9);
  border-radius: 8px;
  height: clamp(32px, 4.5vh, 40px); 
  padding: 0 clamp(10px, 1.2vw, 14px);
  cursor: pointer;
  font-size: clamp(12px, 1.2vw, 14px);
  color: #2c3e50;
  transition: all 0.2s;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.03), 0 1px 2px rgba(255,255,255,0.8);
}
.belong-trigger:hover {
  border-color: rgba(64, 158, 255, 0.8);
  background: rgba(255, 255, 255, 0.8);
}
.belong-placeholder { color: #999; }
.belong-selected-text { color: #333; }
.belong-arrow {
  font-size: 12px;
  color: #999;
  transition: transform 0.2s;
}
.belong-arrow.open { transform: rotate(180deg); }

/* 下拉面板 */
.belong-panel {
  margin-top: 4px;
  background: rgba(255, 255, 255, 0.98); 
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.9); 
  border-radius: 10px;
  padding: 0; 
  display: flex;
  flex-direction: column;
  box-shadow: 0 12px 32px rgba(0,0,0,0.12), inset 0 1px 2px rgba(255,255,255,1);
  max-height: 180px; 
  
  /* 👇 用绝对定位，但宽度强制 100% 匹配父级 */
  position: absolute;
  left: 0;
  top: 100%; /* 直接贴在上方触发框的下沿 */
  width: 100%; 
  box-sizing: border-box; 
  
  overflow-y: auto;
  overflow-x: hidden; 
  -webkit-overflow-scrolling: touch;
  z-index: 99;
  scrollbar-width: none;
}
.belong-panel::-webkit-scrollbar { display: none; }

/* 每一行 */
.belong-row {
  display: flex;
  align-items: center;
  padding: 6px 10px; 
  gap: 6px;
  cursor: pointer;
  transition: background-color 0.15s;
  border-bottom: 1px solid rgba(0,0,0,0.03);
  
  /* 👇 核心修复2：强制盒子计算包含内边距，宽度绝对不超出父级 */
  box-sizing: border-box;
  width: 100%; 
}
.belong-row:first-child { border-radius: 10px 10px 0 0; }
.belong-row:last-child { border-bottom: none; border-radius: 0 0 10px 10px; }
.belong-row:hover { background-color: rgba(64, 158, 255, 0.08); }
.type-dot {
  width: clamp(4px, 0.5vw, 6px);
  height: clamp(4px, 0.5vw, 6px);
  border-radius: 50%;
  background: #f56c6c;
  flex-shrink: 0;
  box-shadow: 0 0 0 3px rgba(245, 108, 108, 0.15);
}
.belong-type-label {
  font-size: clamp(11px, 1.1vw, 13px);
  font-weight: 600;
  color: #2b2b2b;
  white-space: nowrap;
  width: clamp(56px, 5vw, 66px);
  text-align: justify;
  text-align-last: justify;
  margin-right: clamp(8px, 1.5vw, 14px);   
}
/* 标签容器 */
.belong-tags {
  display: flex;
  gap: 6px; /* 间距收紧凑一点 */
  flex-wrap: wrap;
  flex: 1;
  min-width: 0; 
}

/* 小组标签（按你的最终要求提纯） */
.belong-tag {
  /* 👇 采用你给出的黄金参数 */
  padding: 2px clamp(6px, 1vw, 10px);
  border: 1px solid #409eff;
  background: rgba(255, 255, 255, 0.8);
  color: #409eff;
  border-radius: 4px;
  cursor: pointer;
  font-size: clamp(10px, 1vw, 12px);
  transition: 0.2s;
  white-space: nowrap;
  user-select: none;
}

/* 悬浮态：变红 */
.belong-tag:hover {
  border-color: #f56c6c; 
  color: #f56c6c; 
  background: rgba(255, 245, 245, 0.9); /* 微微给一点红晕底 */
}

/* 选中态（active）：纯红底白字 */
.belong-tag.active {
  background: #f56c6c; 
  color: #fff;
  border-color: #f56c6c;
}
.feedback-link {
  color: #409eff;
  cursor: pointer;
  text-decoration: underline;
  margin-left: 2px;
}
.feedback-link:hover { color: #337ecc; }

/* ============================================================
   8. 上传遮罩（高光弹窗）
   ============================================================ */
.upload-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(4px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.upload-box {
  /* 👇 换成和全站一致的高光磨砂玻璃 */
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 1);
  padding: clamp(16px, 3vw, 24px);
  border-radius: 16px;
  width: clamp(260px, 80vw, 320px);
  text-align: center;
  box-shadow: 
    0 20px 50px rgba(0,0,0,0.15), 
    inset 0 2px 6px rgba(255,255,255,1);
}
.upload-box h3 {
  margin: 0 0 15px 0;
  font-size: clamp(15px, 1.5vw, 18px);
  color: #2c3e50;
  font-weight: 700;
}
.upload-tip {
  font-size: clamp(11px, 1vw, 13px);
  color: #888;
  margin-top: 12px;
}
/* ============================================================
   9. 自定义提示弹窗（统一风格）
   ============================================================ */
.tip-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(4px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tip-panel {
  background-image: url("~@/assets/subtle.webp");
  background-repeat: repeat;
  background-size: 420px auto;
  background-position: center;
  background-color: rgba(247, 243, 233, 0.98);
  border-radius: 16px;
  padding: clamp(20px, 4vw, 32px) clamp(24px, 5vw, 40px);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25), inset 0 1px 2px rgba(255,255,255,1);
  border: 1px solid rgba(255, 255, 255, 0.8);
  text-align: center;
  max-width: clamp(280px, 80vw, 400px);
}
.tip-text {
  margin-bottom: 24px;
}

/* 👇 标题：保持加粗，稍微黑一点 */
.tip-title {
  font-size: clamp(15px, 1.6vw, 17px);
  color: #2c3e50; /* 深蓝灰 */
  font-weight: 700; /* 保持加粗 */
  margin-bottom: 8px; /* 和下方文字拉开一点距离 */
}

/* 👇 正文：正常字体，稍微小一点 */
.tip-desc {
  font-size: clamp(13px, 1.4vw, 15px);
  color: #555; /* 柔和灰 */
  font-weight: normal; /* 正常字体 */
  line-height: 1.6;
}
.tip-btn-group {
  display: flex;
  justify-content: center;
  gap: 16px;
}
.tip-btn {
  padding: clamp(3px, 0.8vh, 5px) clamp(6px, 1vw, 8px);
  border-radius: 8px;
  font-size: clamp(13px, 1.3vw, 15px);
  font-weight: 600;
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.3);
  transition: all 0.2s;
}
.tip-btn.cancel {
  background: linear-gradient(to bottom, rgba(255,255,255,0.4), rgba(255,255,255,0.1)), rgba(144, 147, 153, 0.85);
  color: #fff;
}
.tip-btn.confirm {
  background: linear-gradient(to bottom, rgba(255,255,255,0.25), rgba(255,255,255,0) 50%), rgba(64, 158, 255, 0.85);
  color: #fff;
}
.tip-btn:hover {
  transform: translateY(-1px);
}
</style>